/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import { ConversationAssistantButtonNav4 } from '@atlassian/conversation-assistant-ui-components/ui/ConversationAssistantButton';

/** Props for the Ask Rovo toolbar button. */
export type AskRovoToolbarButtonProps = {
	onClick: () => void;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const buttonWrapperStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles -- Remove TopNavButton ::after border
	'& button': { '&::after': { display: 'none' } },
});

/**
 * Renders the Ask Rovo button for the native embed floating toolbar.
 */
export function AskRovoToolbarButton({
	onClick,
}: AskRovoToolbarButtonProps): React.JSX.Element {
	return (
		<div css={buttonWrapperStyles}>
			<ConversationAssistantButtonNav4
				isActive={false}
				onClick={onClick}
				siteId={"stub-site-id"}
				productKey={"confluence"}
			/>
		</div>
	);
}
